export default __webpack_public_path__ + "static/media/logo512.5b5477fc.png";